import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./node_modules/macarons-graphs-front/src/events.js